module.exports = __webpack_public_path__ + "c_static/img/京东个人信息.c791da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/截图示范/京东个人信息.png
// module id = Q5RI
// module chunks = 33